<template>
  <div class="w-100">
    <div class="chat-container w-100">
  		<div class="my-5" v-if="is_load">
  			<loader />
  		</div>
  	  <div v-else>
        <div class="m-4" v-if="error != ''">
          <ErrorMessage :message="error" />
        </div>
        <template v-else>
    	    <div class="container position-relative">
            <p class="sub-heading-1-1 w-100 mt-3 text-center mb-5">{{$t('general.payment-status')}}</p>
    	      <div class="rounded-100 d-table mx-auto mb-4">
    	        <div class="rounded-100 size-icon-in" :class="{
                'bg-green': data.status == 'SUCCESS',
                'bg-orange': data.status == 'UNPAID',
                'bg-danger': data.status == 'CANCELLED'
              }">
    	          <img v-if="data.status == 'SUCCESS'" src="../../../assets/img/icon/correct-white.png" width="40" style="margin: 20px 20px">
                <img v-if="data.status == 'UNPAID'" src="../../../assets/img/icon/history-white.png" width="40" class="position-relative" style="margin: 20px 20px">
                <img v-if="data.status == 'CANCELLED'" src="../../../assets/img/icon/cancel.png" width="40" class="position-relative" style="margin: 20px 20px">
    	        </div>
    	      </div>
    	      <p class="sub-heading-1-2 mt-4 mb-2 mb-0 text-center w-100">{{payment_status}}</p>
            <!-- SUCCESS -->
            <div class="px-4" v-if="data.status == 'SUCCESS' || data.status == 'CANCELLED' || (data.payment_channel.payment_method == 'CREDIT_CARD' && data.status == 'UNPAID')">
              <div class="row slim-grid-row mb-2">
                <div class="col-6 text-left">
                  <p class="body-2-2-1 mb-0">{{$t('general.date')}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="body-2-4 mb-0">{{formatDate(data.created_at)}}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-2">
                <div class="col-6 text-left">
                  <p class="body-2-2-1 mb-0">{{$t('general.payment-method')}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="body-2-4 mb-0">{{parsingPaymentMethod(data.payment_channel.payment_method)}}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-2">
                <div class="col-6 text-left">
                  <p class="body-2-2-1 mb-0">{{$t('general.total-bill')}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="body-2-4 mb-0">{{formatCurrency(data.total_bill)}}</p>
                </div>
              </div>
              <div v-if="parseInt(data.payment_surcharge) > 0" class="row slim-grid-row mb-2 border-light-bottom pb-2">
                <div class="col-6 text-left">
                  <p class="body-2-2-1 mb-0">{{$t('hotel.payment-surcharge')}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="body-2-4 mb-0">{{formatCurrency(data.payment_surcharge)}}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-5">
                <div class="col-6 text-left">
                  <p class="body-2-2-1 mb-0">{{$t('hotel.concierge.total-paid')}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="body-2-4 mb-0">{{formatCurrency(data.total_paid)}}</p>
                </div>
              </div>
    	        <button type="button" class="w-100" :class="{'button-primary':data.status == 'SUCCESS','button-black':data.status == 'CANCELLED' || (data.payment_channel.payment_method == 'CREDIT_CARD' && data.status == 'UNPAID')}" @click="goToHome">{{$t('hotel.action.back-to-homepage')}}</button>
            </div>

            <!-- UNPAID -->
            <template v-if="data.status == 'UNPAID'">
              <VirtualAccountBank v-if="data.payment_channel.payment_method == 'VIRTUAL_ACCOUNT' && data.payment_channel.bank_name == 'JOKUL_DOKU'" :data="data" type="concierge"></VirtualAccountBank>
              <qris-form v-if="data.payment_channel.payment_method == 'QRIS'" :data="data.payment_details" />
              <VirtualAccountForm v-if="data.payment_channel.payment_method == 'VIRTUAL_ACCOUNT' && data.payment_channel.bank_name == 'BPD_BALI'" type="hotel" :data="data.payment_details" :tx_date="data.created_at"></VirtualAccountForm>
              <div class="px-4">
                <button type="button" class="button-secondary w-100" @click="loadDetailPayment">{{$t('hotel.action.check-payment-status')}}</button>
              </div>
            </template>
    	    </div>
        </template>	    
  	  </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
	import {post,get} from '@/services/index.js';
	import moment from 'moment';
	import cartHeader from '@/components/hotel/cartHeader';
	import {formatCurrency,paymentMethodConverter,formatDate} from '@/utils/index.js';
  import QrisForm from '@/components/ticket/QrisForm';
  import VirtualAccountForm from '@/components/hotel/VirtualAccountForm';
  import VirtualAccountBank from '@/components/hotel/be/VirtualAccountBank';

  export default{
    components: {
      QrisForm,
      VirtualAccountForm,
      VirtualAccountBank
    },
    metaInfo(){
      return {
        title: 'Payment Result',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
        is_load: true,
        error: '',
        data: {},
      }
    },
    computed:{
      payment_status(){
        let display = ''
        if(this.data.status == 'SUCCESS'){
          display = this.$t('general.payment-success')
        }else if(this.data.status == 'UNPAID'){
          display = this.$t('general.waiting-for-payment')
        }else if(this.data.status == 'CANCELLED'){
          display = this.$t('general.payment-failed')
        }else{
          display = this.data.status
        }
        return display
      }
		},
    mounted() {
      this.loadDetailPayment()
    },
    methods: {
      ...mapGetters([
        'getMerchant',
        'getMetaTitleTemplate'
      ]),
      formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        return formatDate(date);
      },
      goToHome(){
        this.$router.push(`/${this.getMerchant().code}/concierge`)
      },
      parsingPaymentMethod(pm){
        return paymentMethodConverter(pm)
      },
      loadDetailPayment(){
        this.is_load = true
        get("CONCIERGE",`tx-guest-bill-detail/${this.$route.params.reservation_id}/${this.$route.params.tx_payment_id}`,{},'concierge_pin').then(response=>{
          let res = response.data
          if(res.success){
            this.data = res.data
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
      }
    },
  }
</script>
<style scoped>
  
  .snow{
    position: fixed;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
  }

  .size-icon {
    width: 85px;
    height: 85px;
    padding: 7px;
  }

  .size-icon-in {
    width: 80px;
    height: 80px
  }

  .hide-scroll::-webkit-scrollbar {
    display: none;
  }

  .hide-scroll {
    -ms-overflow-style: none;
  }

  .height-img{
    height: 65px;
  }

  .note{
    margin-top: 0px;
  }

  .h-auto{
  	height: auto!important;
  }

  .discon{
    margin-top: -8px;
  }

</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/ConciergePaymentResult.vue